"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- qa ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

/* ----- course tab ----- */
$(".course__tab").on("click", function() {
  const index = $(this).index();

  // タブのアクティブ状態を切り替え
  $(".course__tab").removeClass("is-active");
  $(this).addClass("is-active");

  // コンテンツの表示切り替え
  $(".course__wrap").removeClass("is-active");
  $(".course__wrap").eq(index).addClass("is-active");
});

$(".megaMenu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

document.addEventListener('DOMContentLoaded', function() {
    const menuBtn = document.querySelector('.menu__btn');
    const menu = document.querySelector('.menu');

    menuBtn.addEventListener('mouseenter', function() {
        menuBtn.classList.add('is-active');
        menu.classList.add('is-active');
    });

    menuBtn.addEventListener('mouseleave', function() {
        menuBtn.classList.remove('is-active');
        menu.classList.remove('is-active');
    });

    menu.addEventListener('mouseenter', function() {
        menuBtn.classList.add('is-active');
        menu.classList.add('is-active');
    });

    menu.addEventListener('mouseleave', function() {
        menuBtn.classList.remove('is-active');
        menu.classList.remove('is-active');
    });
});



// 共通のスライダー設定関数（エラーログのみ）
function initSplide(selector, options) {
  const element = document.querySelector(selector);
  if (element) {
    const track = element.querySelector('.splide__track');
    const list = element.querySelector('.splide__list');

    if (track && list) {
      try {
        new Splide(element, options).mount();
      } catch (error) {
        console.error(`${selector} スライダーの初期化に失敗:`, error);
      }
    }
  }
}

// DOMが読み込まれたときに実行
document.addEventListener('DOMContentLoaded', function () {
  // FVスライダーの設定
  // initSplide('.fv__slider', {
  //   autoplay: true,
  //   type: 'loop',
  //   pauseOnHover: false,
  //   pauseOnFocus: false,
  //   pagination: false,
  //   interval: 5000,
  //   speed: 1000,
  //   padding: '2.5%',
  //   gap: 20,
  //   arrows: false,
  //   classes: {
  //     pagination: 'splide__pagination your-class-pagination',
  //     page: 'splide__pagination__page your-class-page',
  //   },
  //   breakpoints: {
  //     767: {
  //       padding: '0',
  //     },
  //   },
  // });

  // topCase__sliderの設定（Swiper）
  new Swiper('.topCase__slider', {
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    speed: 1000,
    slidesPerView: 1.2,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 40,
      },
    },
  });

  // ambassadors__sliderの設定（Swiper）
  new Swiper('.ambassadors__slider', {
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    speed: 1000,
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: '.ambassadors__slider .swiper-button-next',
      prevEl: '.ambassadors__slider .swiper-button-prev',
    },
    breakpoints: {
      1200: {
        slidesPerView: 1.9,
        spaceBetween: 30,
      },
    },
  });

  // topColumn__slider
  // スライド数を取得
  const slider = document.querySelector('.topColumn__slider');
  const slideCount = slider ? slider.querySelectorAll('.splide__slide').length : 0;

  initSplide('.topColumn__slider', {
    // type: 'loop',
    // autoplay: true,
    type: slideCount >= 4 ? 'loop' : 'slide', // 4記事以上でloop
    autoplay: slideCount >= 4, // 4記事以上で自動再生
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 5000, // 少し長めに設定
    speed: 800, // 少し早めのアニメーション
    gap: 31,
    pagination: false,
    perPage: 3,
    perMove: 1, // 1記事ずつ移動
    easing: 'ease-out', // イージング効果を追加
    padding: {
      left: 0,
      right: '15%',
    },
    breakpoints: {
      767: {
        perPage: 1,
        perMove: 1,
        // gap: 0,
        padding: 0,
        interval: 3000, // モバイルでは少し早めに
      },
    },
  });
});




/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};

// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}



/* ----- 下部CTA ----- */
document.addEventListener('DOMContentLoaded', () => {
  const fixedLink = document.querySelector('.banner');

  // 最初は非表示
  fixedLink.style.opacity = '0';
  fixedLink.style.visibility = 'hidden';

  document.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const showAfterScroll = 300; // 300pxスクロールしたら表示

    if (scrollTop + windowHeight >= documentHeight) {
      // ページの一番下に到達したら非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    } else if (scrollTop > showAfterScroll) {
      // 300px以上スクロールしたら表示
      fixedLink.style.opacity = '1';
      fixedLink.style.visibility = 'visible';
    } else {
      // それ以外は非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    }
  });
});
